// extracted by mini-css-extract-plugin
export default {"howBuyInCredit":"xtzOo","title":"vIgs6","list":"WJe5f","listItem":"jzivC","notes":"rzRJJ","note":"tvTff"};